var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('MarketOrders',{attrs:{"orderType":'mdKeeperMarket'}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }